<template>
  <b-modal
    v-model="localIsVisible"
    size="xl"
    hide-footer
    @cancel="onCancel"
  > 
    <div v-if="showFormRespiratorio">

      <FormTerapiaRespiratoria
      :dataTerapia="dataTerapia"
    />
    </div>
    
    <div v-if="showFormNutricional"> 
      <FormTerapiaNutricional
      :dataTerapia="dataTerapia"
    />

    </div>
   
    <div v-if="showFormPsicologica">
      <FormTerapiaPsicologica
      :dataTerapia="dataTerapia"
    />
    </div>
   
  </b-modal>
</template>

<script>
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import FormTerapiaRespiratoria from "./FormTerapiaRespiratoria.vue";
import FormTerapiaNutricional  from "./FormTerapiaNutricional.vue";
import FormTerapiaPsicologica from "./FormTerapiaPsicologica.vue";

export default {

  name: "ModalProcesarTerapia",

  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    
    idTerapia:{
      type: String,
      default: null
    }
    
  },

  components: {
    FormTerapiaRespiratoria,
    FormTerapiaNutricional,
    FormTerapiaPsicologica
  },

  data() {
    return {
      localIsVisible: false,
      
      showFormRespiratorio: false,      
      showFormPsicologica: false,    
      showFormNutricional: false,
      showFormInforme: false,
      
      dataTerapia:{
        id:null,
        tipo:null,
        tipoText:null,
        nombre:null,
        codigo:null,
        fechaProgramada:null,
        doctorNombre:null,
        pacienteNombre:null,
        pacienteOcupacion:null,
        antecedentesFamiliares:null,
        antecedentesPersonales:null
      },
    };
  },

 

  methods: {
    
    onCancel() {
      this.localIsVisible = false
    },


    async onLoadDataTerapia( idTerapia ) {
      this.showFormRespiratorio= false   
      this.showFormPsicologica= false
      this.showFormNutricional= false
      this.showFormInforme= false
      
      const response = await this.fetchTerapiaById( idTerapia );
      
      if(!response.status === 200) return;
      
      const dataTerapia = response.data.data.solicitudTerapia.solicitudTerapia;
      const idSolicitudTerapia = dataTerapia.id
      const tipo = dataTerapia.terapia ?  dataTerapia.terapia.tipoTerapia.id : 'No disponible'
      const tipoText = dataTerapia.terapia ?  dataTerapia.terapia.tipoTerapia.descripcion : 'No disponible'
      const { id, nombre, codigo,  } = dataTerapia.terapia;
      const { fechaProgramada }      = dataTerapia;
      const motivoSolicitud = dataTerapia.motivoSolicitud;

      const paciente = dataTerapia.consultamedica.cita.paciente.persona;
      const pacienteNombre = `${paciente.primerApellido} ${paciente.primerNombre}`;
      const pacienteOcupacion = paciente.ocupacion ? paciente.ocupacion.descripcion : "No disponible"
      const pacientesexo = paciente.sexo || "No disponible"
      
      const pacEdad = this.calcularEdad(paciente.fechaNacimiento)

      const doctor = dataTerapia.consultamedica.cita.doctor.idPersona;
      const doctorNombre = `${doctor.primerApellido} ${doctor.primerNombre}`;

      const antecedentesFamiliares = dataTerapia.consultamedica.antefamanamSet;
      const antecedentesPersonales = dataTerapia.consultamedica.anteperanamSet;

      this.dataTerapia = {
        id,
        idSolicitudTerapia,
        tipo,
        tipoText,
        nombre,
        codigo,
        fechaProgramada,
        doctorNombre,
        pacienteNombre,
        pacientesexo,
        motivoSolicitud,
        pacEdad,
        pacienteOcupacion,
        antecedentesFamiliares,
        antecedentesPersonales
      };
      this.onShowForm(tipoText)
      
    },

    calcularEdad(fechaNacimiento) {
    const hoy = new Date();
    const nacimiento = new Date(fechaNacimiento);
    let edad = hoy.getFullYear() - nacimiento.getFullYear();
    const mes = hoy.getMonth() - nacimiento.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
        edad--;
    }

    return edad;
},


    onShowForm(tipo) {
      const tipoTerapia = tipo;
      console.log(tipoTerapia)
      if (tipoTerapia === "RESPIRATORIA") 
        this.showFormRespiratorio = true;
      
      if ( tipoTerapia === "PSICOTERAPIA")
        this.showFormPsicologica = true;
      
      if ( tipoTerapia === "NUTRICION")
        this.showFormNutricional = true;

      if ( tipoTerapia === "TERAPIA GENERAL")
        this.showFormInforme = true;
      
    },


    async fetchTerapiaById(idSolicitudTerapia) {
      const query = `
        query GetSolicitudTerapia($idSolicitudTerapia: String!) {
          solicitudTerapia(idSolicitudTerapia: $idSolicitudTerapia) {
            status
            message

            solicitudTerapia{
              id
              fechaProgramada
              motivoSolicitud
              estadoTerapia
              terapia{
                id
                nombre
                codigo
                tipoTerapia{
                  id
                  descripcion
                }
              }

              consultamedica {
                antefamanamSet {
                  descripcionGeneral
                  antescedentesFamiliares {
                    descripcion
                    id
                  }
                  
                }
                anteperanamSet {
                  descripcionGeneral
                  id
                  antescedentesPersonales {
                    descripcion
                  }
                }
                  
                cita {
                  paciente {
                    persona {
                      fechaNacimiento
                      sexo
                      primerNombre
                      primerApellido
                      identificacion
                      ocupacion {
                        descripcion
                      }
                    }
                  }
                  doctor {
                    idPersona {
                      primerNombre
                      primerApellido
                    }
                  }
                }

              }
            }
          }
        }
      `;

      const variables = {
        idSolicitudTerapia: idSolicitudTerapia,
      };

      try {
        const response = await axios.post(rutas.axios + "api", {
          query,
          variables,
        });

        return response;
        
      } catch (error) {
        console.error("Error fetching terapias programadas:", error);
        return error;
      }
    },


    // async fetchTerapiaById(idSolicitudTerapia) {
    //   const query = `
    //     query GetSolicitudTerapia($idSolicitudTerapia: String!) {
    //       solicitudTerapia(idSolicitudTerapia: $idSolicitudTerapia) {
    //         status
    //         message

    //         solicitudTerapia{
    //           id
    //           fechaProgramada
    //           estadoTerapia
    //           terapia{
    //             id
    //             nombre
    //             codigo
    //             tipoTerapia{
    //               id
    //               descripcion
    //             }
    //           }

    //           consultamedica {
    //             antefamanamSet {
    //               descripcionGeneral
    //               antescedentesFamiliares {
    //                 descripcion
    //                 id
    //               }
                  
    //             }
    //             anteperanamSet {
    //               descripcionGeneral
    //               id
    //               antescedentesPersonales {
    //                 descripcion
    //               }
    //             }
                  
    //             cita {
    //               paciente {
    //                 persona {
    //                   primerNombre
    //                   primerApellido
    //                   identificacion
    //                   ocupacion {
    //                     descripcion
    //                   }
    //                 }
    //               }
    //               doctor {
    //                 idPersona {
    //                   primerNombre
    //                   primerApellido
    //                 }
    //               }
    //             }

    //           }
    //         }
    //       }
    //     }
    //   `;

    //   const variables = {
    //     idSolicitudTerapia: idSolicitudTerapia,
    //   };
    //   try {
    //     const response = await axios.post(rutas.axios + "api", {
    //       query,
    //       variables: variables,
    //     });

    //     console.log(response);

    //     if (response.status === 200) {
          
    //       this.tipoterapia =
    //         response.data.data.solicitudTerapia.solicitudTerapia.terapia.tipoTerapia.id;
    //       if (
    //         response.data.data.solicitudTerapia.solicitudTerapia.consultamedica
    //           .antefamanamSet.length > 0
    //       ) {
    //         let anteFam =
    //           response.data.data.solicitudTerapia.solicitudTerapia
    //             .consultamedica.antefamanamSet[0].descripcionGeneral;

    //         this.camposDetallesPaciente[0].antecedentes_familiares = anteFam;
    //       } else {
    //         this.camposDetallesPaciente[0].antecedentes_familiares = "Ninguno";
    //       }

    //       let anteperanamSet =
    //         response?.data?.data?.solicitudTerapia?.solicitudTerapia
    //           ?.consultamedica?.anteperanamSet;

    //       if (anteperanamSet?.length > 0) {
    //         this.camposDetallesPaciente[0].antecedentes_personales =
    //           anteperanamSet[0].descripcionGeneral;
    //       } else {
    //         this.camposDetallesPaciente[0].antecedentes_personales = "Ninguno";
    //       }

    //       if (
    //         response.data.data.solicitudTerapia.solicitudTerapia.consultamedica
    //           .cita.paciente.persona.ocupacion
    //       ) {
    //         let ocupa =
    //           response.data.data.solicitudTerapia.solicitudTerapia
    //             .consultamedica.cita.paciente.persona.ocupacion.descripcion;
    //         this.camposDetallesPaciente[0].ocupacion = ocupa;
    //       } else {
    //         this.camposDetallesPaciente[0].ocupacion = "Ninguno";
    //       }

    //       this.informacionTerapia.terapia =
    //         response.data.data.solicitudTerapia.solicitudTerapia.terapia.nombre;
    //       this.informacionTerapia.codigoTerapia =
    //         response.data.data.solicitudTerapia.solicitudTerapia.terapia.codigo;
    //       this.informacionTerapia.fechaProgramada =
    //         response.data.data.solicitudTerapia.solicitudTerapia.fechaProgramada;
    //       this.informacionTerapia.id =
    //         response.data.data.solicitudTerapia.solicitudTerapia.id;
    //       this.informacionTerapia.primerNombre =
    //         response.data.data.solicitudTerapia.solicitudTerapia.consultamedica.cita.paciente.persona.primerNombre;
    //       this.informacionTerapia.primerApellido =
    //         response.data.data.solicitudTerapia.solicitudTerapia.consultamedica.cita.paciente.persona.primerApellido;
    //       this.informacionTerapia.tipoTerapia = response.data.data.solicitudTerapia.solicitudTerapia.terapia.tipoTerapia.descripcion,
        
    //       (this.informacionTerapia.nombresDoctor =
    //         response.data.data.solicitudTerapia.solicitudTerapia.consultamedica
    //           .cita.doctor.idPersona.primerNombre +
    //         response.data.data.solicitudTerapia.solicitudTerapia.consultamedica
    //           .cita.doctor.idPersona.primerApellido),
    //         console.log(this.informacionTerapia.codigoTerapia);
    //     }
    //   } catch (error) {
    //     console.error("Error fetching terapias programadas:", error);
    //   }
    // },
  },


  watch: {

    idTerapia(newValue) {
      this.onLoadDataTerapia(newValue);
      
    },

    isVisible(newValue) {
      this.localIsVisible = newValue;
    },

    localIsVisible(newValue) {
      this.$emit('update:isVisible', newValue);
    }
  }


}
</script>
